const styleSheet = () => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    height: '390px',
    width: '560px',
    borderRadius: '8px',
    backgroundColor: '#F8F9FB',
    boxShadow: '0 4px 20px 0 rgba(0,0,0,0.4)',
  },
  error: {
    color: '#FF6969',
    fontSize: '12px',
    letterSpacing: 0,
    padding: '0 14px',
    marginTop: '5px',
  },
  flexCenter: {
    // vertically and horizontally
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  rowsWrapper: {
    width: '384px',
    borderRadius: '4px',
    backgroundColor: '#FFFFFF',
    boxShadow: '0 2px 4px 0 rgba(0,0,0,0.15)',
  },
  listContainer: {
    cursor: 'pointer',
    margin: '0 auto',
    width: '384px',
    borderRadius: '4px',
    backgroundColor: '#FFFFFF',
    boxShadow: '0 2px 4px 0 rgba(0,0,0,0.15)',
    '& > div': {
      borderBottom: '1px solid #D8DCE6',
    },
    '& > div:last-child': {
      borderBottom: '0px solid #D8DCE6',
    },
  },
  svgWrapper: {
    display: 'flex',
    alignItems: 'center',
    height: '40px',
  },
  lockSvg: {
    height: '14px',
    width: '11px',
    '& path': {
      fill: '#6373A4',
    },
  },
  radioButtonRows: {
    height: '81px',
    width: '100%',
  },
  radioButtonWrapper: {
    paddingTop: '21px',
    paddingBottom: '42px',
    paddingLeft: '16px',
    paddingRight: '0px',
  },
  radioButtonCol1: {
    width: '52px',
  },
  radioButtonCol2: {
    width: '285px',
    paddingBottom: '5px',
  },
  radioButtonCol3: {
    width: '56px',
    paddingLeft: '2px',
  },
  radioButtonBoldText: {
    height: '19px',
    color: '#051D39',
    fontFamily: "'Museo Sans', sans-serif",
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '19px',
  },
  radioButtonSecondaryText: {
    height: '19px',
    width: '262px',
    color: '#6373A4',
    fontFamily: "'Museo Sans', sans-serif",
    fontSize: '14px',
    fontWeight: '500',
    lineHeight: '19px',
  },
  row: {
    // Adding a flex row
    display: 'flex',
    flexDirection: 'row',
  },
  col: {
    display: 'flex',
    flexDirection: 'column',
  },
  cursor: {
    cursor: 'pointer',
  },
  title: {
    height: '30px',
    color: '#051D39',
    fontFamily: "'Museo Sans', sans-serif",
    fontSize: '24px',
    fontWeight: 700,
    lineHight: '30px',
    paddingBottom: '36px',
    textTransform: 'capitalize',
  },
  buttonColWidth: {
    width: '50%;',
  },
  button: {
    height: '40px',
    width: '95px',
    borderRadius: '4px',
    '&:focus': {
      outline: 'none',
    },
  },
  btnCancel: {
    backgroundColor: '#F8F9FB',
    border: 'solid 1px #F8F9FB',
  },
  cancelPadding: {
    paddingRight: '36px',
  },
  btnSave: {
    backgroundColor: '#085FE5',
    border: 'solid 1px #085FE5',
  },
  buttonLabels: {
    height: '18px',
    fontFamily: "'Museo Sans', sans-serif",
    fontSize: '14px',
    fontWeight: '500',
    lineHht: '18px',
  },
  btnCancelLabel: {
    width: '46px',
    color: '#085FE5',
  },
  btnSaveLabel: {
    width: '31px',
    color: '#fff',
  },
  controls: {
    marginTop: '61px',
    display: 'flex',
    justifyContent: 'center',
    '& > *': {
      marginRight: '32px',
    },
    '& :last-child': {
      marginRight: 0,
    },
  },
});

export default styleSheet;
